import {useMemo} from 'react'
import {useReviews} from './use-reviews'

export function useRequestedChangesReviews() {
  const reviewSummaries = useReviews()

  return useMemo(
    () => reviewSummaries.filter(reviewSummary => reviewSummary.state === 'CHANGES_REQUESTED'),
    [reviewSummaries],
  )
}
